import React, { FC } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./LoginCarousel.scss";
import MobileLoginStartup from "./MobileLoginStartup";
import useWindowSize from "../../../hooks/useWindowSize";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import WebLoginStartup from "./WebLoginStartup";
import { Dialog } from "@mui/material";

interface Props {
  open: boolean;
  setLoginCarousel: Function;
}
const LoginCarousel: FC<Props> = ({ open, setLoginCarousel }) => {
  const { width } = useWindowSize();
  const handleClosePopup = () => {
    setLoginCarousel(false);
  };

  return (
    <>
      {width >= 900 ? (
        <CustomPopup
          btnLabel="Close"
          btnStartIcon={<CloseIcon sx={{ fontSize: "1rem" }} />}
          open={open}
          handleOpen={handleClosePopup}
          className={"common-custom-popup-style web-login-startup-popup"}
        >
          <WebLoginStartup setLoginCarousel={setLoginCarousel} />
        </CustomPopup>
      ) : (
        <Dialog fullScreen open={open}>
          <MobileLoginStartup setLoginCarousel={setLoginCarousel} />
        </Dialog>
      )}
    </>
  );
};

export default LoginCarousel;
